import React, { Component } from "react";
import ReactGA from "react-ga4";
import JukinFooter from 'jukin-footer';

class Footer extends Component {
  
  analytics = (...args) => ReactGA.ga(...args);
  
  render () {
    return <JukinFooter funkUrl={process.env.REACT_APP_FUNK_URL || "https://jukinmedia.com"} analytics={this.analytics} message="LP-Footer"/>
  }
}

export default Footer;
